module.exports = __webpack_public_path__ + "img/501.31dc7d87.jpg";